import { IFormatObjectEditable } from "..";
import { IFormatAlert } from "../IFormatAlert";
import { IObjectValidator } from "../IObjectValidator";
import { ScriptObjectEditor } from "../objectEditors";
import { ObjectAlert } from "../alerts";

export class ScriptObjectValidator implements IObjectValidator {
  public validate(object: IFormatObjectEditable): IFormatAlert[] {
    const alerts: ObjectAlert[] = [];
    if (object instanceof ScriptObjectEditor) {
      const tableIndex = object.tableIndex().getValue();
      if (tableIndex.row === 0 && tableIndex.column === 0) {
        const behavior = object.tableScriptExecuteBehavior().getValue();
        if (!behavior.scriptPath) {
          alerts.push(new ObjectAlert(object, "実行ファイルパスを設定してください。"));
        }

        if (!behavior.csvFilePathFormat) {
          alerts.push(new ObjectAlert(object, "CSVファイルパスを入力してください。"));
        }

        if (behavior.parameters.length < 1) {
          alerts.push(new ObjectAlert(object, "パラメータを設定をしてください。"));
        }

        const tableSize = object.tableSize().getValue();
        if (tableSize.row < 1) {
          alerts.push(new ObjectAlert(object, "行は1以上の整数を入力してください"));
        }
  
        if (tableSize.column < 1) {
          alerts.push(new ObjectAlert(object, "列は1以上の整数を入力してください"));
        }
      }
    }
    return alerts;
  }
}
